document.addEventListener('DOMContentLoaded', function () {
	var loadingElement = document.getElementById('loading');
	function disableScroll() {
		document.body.style.overflow = 'hidden';
	}

	function enableScroll() {
		document.body.style.overflow = 'auto';
	}

	if (loadingElement) {
		disableScroll();
		loadingElement.addEventListener('animationend', enableScroll, { once: true });
	}else{
		enableScroll();
	}
});
